module.exports = __webpack_public_path__ + "static/img/app-img-02@t.8283682.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/glovis-aa/app-img-02@t.png
// module id = y1nl
// module chunks = 0